module.exports = __webpack_public_path__ + "media/fonts/OpenSans-LightItalic-7e68648a0b1aa736a7e17db2cbded980.ttf";